import React, {useState, useEffect, useContext, useRef} from "react";
import {JWT} from "../constants/local-storage";
import {functions} from "../constants/common-functions";
import {TREE_SELECTOR_TREE_TYPE_SPACE_TYPE} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_TYPE_CLASSIFICATION_ITEM} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_DASHBOARD_SPACE_TYPE} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_DASHBOARD_CLASSIFICATION_ITEM} from "../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {store} from '../context/store';
import TreeSelector from "../components/TreeSelector";

export default function DashboardPhotoNavigatorNonStandard({

    refFacility,
    facilityId,
    setFacilityId,
    floorId,
    setFloorId,
    spaceId,
    setSpaceId,
    classificationId,
    setClassificationId,
    classificationItemId,
    setClassificationItemId,
    spaceTypeId,
    setSpaceTypeId,
    filterBean

}) {	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const refFloor = useRef(null);
	const refSpace = useRef(null);
	
	const [facilities, setFacilities] = useState([]);
	const [spaceTypes, setSpaceTypes] = useState([]);
	const [classificationItems, setClassificationItems] = useState([]);
	const [floors, setFloors] = useState([]);
	const [spaces, setSpaces] = useState([]);
	const [facilityName, setFacilityName] = useState("");
	
	const [photoSource, setPhotoSource] = useState();
	const [photoDisplay, setPhotoDisplay] = useState('none');
	const [imageTextDisplay, setImageTextDisplay] =useState('none');
	
	
	const [displayBuildingView, setDisplayBuildingView] = useState("none");
	
	const queryContext =
				    globalState?.state?.queryContext;
					
					
	const getFilterBean = function()
	{
	    const filterBeanTemp = {};

	    filterBeanTemp.facilities =
	        facilityId !== "-100"
	            ? [parseInt(facilityId)]
	            : [];

	    filterBeanTemp.facilityExcludes = [];

	    filterBeanTemp.floors =
	        floorId !== "-100"
	            ? [parseInt(floorId)]
	            : [];

	    filterBeanTemp.floorExcludes = [];


	    filterBeanTemp.spaces =
	        spaceId !== "-100"
	            ? [parseInt(spaceId)]
	            : [];

	    filterBeanTemp.spaceExcludes = [];

	   
	    filterBeanTemp.classifications = [];
	    filterBeanTemp.classificationExcludes = [];

	    filterBeanTemp.classificationItems = [];
	    filterBeanTemp.classificationItemExcludes = [];

	  

	    return filterBeanTemp;
	};
	
	
	useEffect(() => {

	    if(facilityId === -100){
	        setDisplayBuildingView("none");
	    }
	    else{
	        setDisplayBuildingView("flex");
	    }

	    loadFacility();

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetfloorsforfacility",
	         functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        setFloors
	    );

	    if(floorId === -100){

	        functions.postFilterBeanAjax(
	            "/resolutionsoftwareplatform/utilisationgetspacesforfacility",
	            filterBean,
	            setSpaces
	        );

	    }
	    else{
			
	        functions.postFilterBeanAjax(
	            "/resolutionsoftwareplatform/utilisationgetspacesforfacilityandfloor",
	             functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	            setSpaces
	        );

	    }

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetfacilities",
	         functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        setFacilities
	    );
		

	}, [

	    facilityId,
	    floorId,
	    spaceId,
	    spaceTypeId,
	    classificationId,
	    classificationItemId,
	    queryContext
	]);
	
	
	const loadFacility = () => {
		setImageTextDisplay('none');
		setPhotoDisplay('none');
		functions.getObjectFromAjax("/resolutionsoftwareplatform/getfacilitypopup?facilityId=" + facilityId, null, buildTableRows);
	};
	
	const buildTableRows = (input) => {
		setFacilityName(input.name);
		getClientInfo(input.code, input.photo);
	};
	
	const getClientInfo = (buildingCode, photo) => {
			loadPhoto(globalState.state.client.resourceFolderUrl + "/buildingphotos/" + buildingCode + "/" + photo);
	};
	
	const loadPhoto= (imageUrl) => {
		
		fetch(imageUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    }).then(result => result.blob())
	    .then(result => {
	    	if(result.size > 1000){
	    		setPhotoSource(URL.createObjectURL(result));
		    	setPhotoDisplay('flex');
		    	setImageTextDisplay('none');
	    	}
	    	else{
	    		setImageTextDisplay('flex');
	    	}
	    });
	};
	
	const handleChangeSpaceType = (e) => {
 		setSpaceTypeId(e.target.value);
 	};
 	
 	const handleChangeClassificationItem = (e) => {
 		setClassificationItemId(e.target.value);
 	};
 	
	const handleChangeFacility = (e) => {
 		if(e.target.value === "-100"){
			refFloor.current.value="=100";
			refSpace.current.value="=100";
 			setSpaceId(-100);
 			setFloorId(-100);
 		}
		setFacilityId(parseInt(e.target.value));
 	};
 	
 	const handleChangeFloor = (e) => {
 		if(e.target.value === "-100"){
			refSpace.current.value="=100";
 			setSpaceId(-100);
 		}
		setFloorId(parseInt(e.target.value));
 	};
 	
 	const buildingNavigator = {
 		display:displayBuildingView,
 		flexDirection:"column",
 		width:"100%"
 	};
 	
 	const handleChangeSpace = (e) => {
 		setSpaceId(parseInt(e.target.value));
 	};
	
	const infoBoxHeader = {
		display:"flex",
		width:"100%",
		justifyContent:"space-between"
	};
	
	const infoBoxTitle = {
			display:"flex",
			height:"40px",
			color:"white",
			fontSize:"16px",
			paddingLeft:"20px",
			alignItems:"center"
	};
	
	const buildingPhotoContainer = {
  	display:"flex",
  	marginLeft:"20px",
  	marginTop:"20px",
  	marginRight:"20px",
  	width:"calc(100% - 40px)",
  	alignItems:"center",
  	justifyContent:"space-around",
  	borderRadius:"3px",
  	minHeight:"200px",
  	border:"1px solid lightgrey"
  };
  
  const buildingPhoto = {
  	width:"100%"
  };
  
  const imageText = {
  	color:"white",
  	fontSize:"14px"
  };
  
  const topPanel = {
  	display:"flex",
  	height:"60px"
  }
  
  const topPanelGrey = {
  	display:"flex",
  	backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
  	minHeight:"100px",
  	width:"397px"
  };
  
  const topPanelCurveBackground = {
  	display:"flex",
  	height:"100%",
  	width:"20px",
  	backgroundColor:COLOR_GRAY_BANNER_BACKGROUND
  };
  
  const topPanelCurve = {
  	display:"flex",
  	backgroundColor:"white",
  	width:"100%",
  	height:"100%",
  	borderBottomLeftRadius:"20px"
  };
	
	const leftSelectorContainer = {
 		display:"flex",
 		width:"calc(100% - 40px)",
 		marginLeft:"0px",
 		marginRight:"20px",
 		padding:"10px",
 		borderTopRightRadius:"20px",
 		borderBottomRightRadius:"20px",
 		flexDirection:"column",
 		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND
 		//boxShadow:'0 3px 6px rgba(0,0,0,0.12), 0 3px 6px rgba(0,0,0,0.12)',
 	};
 	
 	const leftSelectPanel = {
 		display:"flex",
 		height:"40px",
 		alignItems:"center",
 		marginLeft:"20px"
 	};
 	
 	const leftSelectPanelLabel = {
 		display:'flex',
 		width:"140px",
 		color:"white",
 		fontSize:'12px',
 		fontWeight:"bold"
 	};
 	
 	const leftSelectPanelSelect = {
 		display:'flex',
 		width:"275px",
 		height:"30px",
 		border:"1px solid lightgrey",
 		borderRadius:"5px",
 		paddingLeft:"10px",
 		fontSize:'12px',
 		color:"white",
 		backgroundColor:"rgba(0,0,0,0)"
 	};
 	
	const spaceTypeOptionDisplay =
	    (spaceTypes || []).map(function(item)
	    {
	        return (
	            <option
	                key={item.id}
	                value={item.id}
	                style={{color:"black"}}
	            >
	                {item.name}
	            </option>
	        );
	    });

	const classificationItemOptionDisplay =
	    (classificationItems || []).map(function(item)
	    {
	        return (
	            <option
	                key={item.id}
	                value={item.id}
	                style={{color:"black"}}
	            >
	                {item.name}
	            </option>
	        );
	    });

	const facilityOptionDisplay =
	    (facilities || []).map(function(item)
	    {
	        return (
	            <option
	                key={item.id}
	                value={item.id}
	                style={{color:"black"}}
	            >
	                {item.name}
	            </option>
	        );
	    });

	const floorOptionDisplay =
	    (floors || []).map(function(item)
	    {
	        return (
	            <option
	                key={item.id}
	                value={item.id}
	                style={{color:"black"}}
	            >
	                {item.name}
	            </option>
	        );
	    });

		const spaceOptionDisplay =
		    Array.isArray(spaces)
		        ? spaces.map(function(item)
		        {
		            return (
		                <option
		                    key={item.id}
		                    value={item.id}
		                    style={{color:"black"}}
		                >
		                    {item.name}
		                </option>
		            );
		        })
		        : [];
	
	return (
			<div style={{margin:'0px'}}>
				<div style={topPanel}>
					<div style={topPanelGrey}/>
					<div style={topPanelCurveBackground}>
						<div style={topPanelCurve}/>
					</div>
				</div>
				<div style={leftSelectorContainer}>
						<TreeSelector
							id="1"
							depth="0"
							dashboardId={TREE_SELECTOR_TREE_DASHBOARD_CLASSIFICATION_ITEM} 
							treeType={TREE_SELECTOR_TREE_TYPE_CLASSIFICATION_ITEM} 
							label="C-R Space Type" 
							childLabel = "C-R Sub Type"
							setFunction={setClassificationItemId} 
							inputId="-100"
							facilityId={facilityId}
							floorId={floorId}
							spaceId={spaceId}
							spaceTypeId={spaceTypeId} 
							classificationId={classificationId}
							classificationItemId={classificationItemId}
							filterBean={filterBean}
						/>
						<TreeSelector
							id="1"
							depth="0"
							dashboardId={TREE_SELECTOR_TREE_DASHBOARD_SPACE_TYPE} 
							treeType={TREE_SELECTOR_TREE_TYPE_SPACE_TYPE} 
							label="Space Category" 
							childLabel="Space Sub Category"
							setFunction={setSpaceTypeId} 
							inputId="-100"
							facilityId={facilityId}
							floorId={floorId}
							spaceId={spaceId}
							spaceTypeId={spaceTypeId} 
							classificationId={classificationId}
							classificationItemId={classificationItemId}
							filterBean={filterBean}
						/>
						<div style={leftSelectPanel}>
							<div style={leftSelectPanelLabel}>
								Building
							</div>
							<select style={leftSelectPanelSelect} onChange={handleChangeFacility} ref={refFacility}>
								<option value="-100">
									Select
								</option>
								{facilityOptionDisplay}
							</select>
						</div>
						<div style={buildingNavigator}>
							
							<div style={buildingPhotoContainer}>
								<img src={photoSource} style={{...buildingPhoto, display:photoDisplay}}/>
								<div style={{...imageText, display:imageTextDisplay}}>
									No image available!
								</div>
							</div>
							<div style={infoBoxHeader}>	
									<div style={infoBoxTitle}>
											{facilityName}
									</div>
							</div>
							<div style={leftSelectPanel}>
								<div style={leftSelectPanelLabel}>
									Floor
								</div>
								<select style={leftSelectPanelSelect} onChange={handleChangeFloor} ref={refFloor}>
									<option value="-100">
										Select
									</option>
									{floorOptionDisplay}
								</select>
							</div>
							<div style={leftSelectPanel}>
								<div style={leftSelectPanelLabel}>
									Room
								</div>
								<select style={leftSelectPanelSelect} onChange={handleChangeSpace} ref={refSpace}>
									<option value="-100">
										Select
									</option>
									{spaceOptionDisplay}
								</select>
							</div>
						</div>
					</div>
				</div>
	);
}